import { createUseStyles } from 'react-jss'
import { HOT_PINK, ORANGE_PINK } from '@omnilert/components'

export default createUseStyles({
  headerContainer: {
    borderBottom: '2px solid var(--header__border__color)',
    flex: 'none',
    position: 'relative',
    userSelect: 'none',
    zIndex: '101'
  },
  headerTitleContainer: {
    alignItems: 'center',
    backgroundColor: 'var(--header__background__color)',
    color: 'var(--header__title__color)',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'BentonSansMedium',
    fontSize: '18px',
    height: '54px',
    justifyContent: 'flex-end',
    position: 'relative'
  },
  headerTitle: {
    marginBottom: '5px'
  },
  helpButton: {
    '& svg': {
      height: '82px',
      fill: HOT_PINK,
      top: '0',
      position: 'absolute',
      '& g > .outerCirlce': {
        fill: HOT_PINK
      }
    },
    background: 'none',
    border: '0',
    cursor: 'pointer',
    height: '60px',
    left: '4px',
    padding: '0',
    position: 'absolute',
    top: '46px',
    zIndex: '10'
  },
  helpText: {
    alignItems: 'center',
    backgroundColor: 'var(--header__emergency-button__background__color)',
    borderTop: '2px solid var(--header__border__color)',
    color: ORANGE_PINK,
    display: 'flex',
    fontFamily: 'BentonSansBold',
    fontSize: '13px',
    height: '58px',
    justifyContent: 'center',
    padding: '0 24px',
    textTransform: 'uppercase',

    '@media (max-width: 667px)': {
      '& span': {
        marginLeft: '85px'
      }
    }
  },
  helpTextContainer: {
    cursor: 'pointer',
    display: 'none',

    '@media (max-width: 667px)': {
      display: 'initial'
    }
  }
})
